import useSWR from "swr"

import { GetPaginatedEmailCommunicationDetailRequest } from "api/emailCommunication/getPaginatedEmailCommunicationApi"
import { systemEmailLogClient } from "services/clients/systemEmailLogClient"

const getEmailCommunicationDetailsFetcher = async ({
  url,
  ...params
}: {
  url: string
} & GetPaginatedEmailCommunicationDetailRequest["params"]) => {
  const searchData = await systemEmailLogClient.getPaginatedLogDetail({
    params,
  })
  return searchData.data.data
}

const usePaginatedEmailLogDetails = (
  params: GetPaginatedEmailCommunicationDetailRequest["params"],
) => {
  return useSWR(
    params
      ? {
          url: `/api/getEmailLogDetails`,
          ...params,
        }
      : null,
    getEmailCommunicationDetailsFetcher,
    {
      revalidateOnFocus: false,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )
}

export default usePaginatedEmailLogDetails
